import {
  Coverage,
  ProductInfo
} from "./chunk-V5XP6XCT.js";

// src/components/CoverageSummary/CoverageSummary.tsx
import classNames3 from "classnames/dedupe";
import { forwardRef } from "react";

// src/components/CoverageSummary/PaymentSummary/PaymentSummary.tsx
import { Flex, SegmentGroup, Segment } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import { jsx, jsxs } from "react/jsx-runtime";
var PaymentSummary = (props) => {
  const { total, toPayToday, instalments } = props;
  const classes = classNames("mobius", "mobius-payment-summary");
  return /* @__PURE__ */ jsxs(SegmentGroup, { className: classes, children: [
    /* @__PURE__ */ jsx(Segment, { className: "mobius-payment-summary__to-pay-today", children: /* @__PURE__ */ jsxs(Flex, { justifyContent: "space-between", children: [
      /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx("strong", { children: "To pay today" }) }),
      /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx("strong", { children: toPayToday }) })
    ] }) }),
    instalments.map(({ count, amount }) => /* @__PURE__ */ jsx(Segment, { className: "mobius-payment-summary__instalments", children: /* @__PURE__ */ jsxs(Flex, { justifyContent: "space-between", children: [
      /* @__PURE__ */ jsxs("span", { children: [
        count,
        " monthly payments of"
      ] }),
      /* @__PURE__ */ jsx("span", { children: amount })
    ] }) }, amount)),
    /* @__PURE__ */ jsx(Segment, { className: "mobius-payment-summary__total", children: /* @__PURE__ */ jsxs(Flex, { justifyContent: "space-between", children: [
      /* @__PURE__ */ jsx("span", { children: "Total (inc. tax + fees)" }),
      /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx("strong", { children: total }) })
    ] }) })
  ] });
};

// src/components/CoverageSummary/QuoteSummary/QuoteSummary.tsx
import classNames2 from "classnames/dedupe";
import { jsx as jsx2 } from "react/jsx-runtime";
var QuoteSummary = (props) => {
  const { quote } = props;
  const classes = classNames2("mobius", "mobius-quote-summary");
  return /* @__PURE__ */ jsx2("div", { role: "listitem", className: classes, children: /* @__PURE__ */ jsx2(
    ProductInfo,
    {
      logo: quote.insurerLogo,
      productTitle: quote.productDescription || quote.covers[0].displayName,
      premium: quote.premium,
      policyStartDate: quote.policyStartDate,
      children: /* @__PURE__ */ jsx2(
        Coverage,
        {
          covers: quote.covers,
          displayVariant: "qcp",
          helpText: quote.helpText
        }
      )
    }
  ) });
};

// src/components/CoverageSummary/CoverageSummary.tsx
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var CoverageSummary = forwardRef(
  (props, ref) => {
    const { className, quotes, paymentInfo, componentName, ...otherProps } = props;
    const classes = classNames3("mobius", "mobius-coverage-summary", className);
    const { variant } = otherProps;
    return /* @__PURE__ */ jsxs2(
      "div",
      {
        ref,
        ...otherProps,
        ...componentName ? { "data-component": componentName } : {},
        ...variant ? { "data-variant": variant } : {},
        className: classes,
        "data-testid": "coverage-summary",
        children: [
          /* @__PURE__ */ jsx3("div", { role: "list", className: "mobius-coverage-summary__list", children: quotes.map((quote) => /* @__PURE__ */ jsx3(QuoteSummary, { quote }, quote.id)) }),
          /* @__PURE__ */ jsx3(PaymentSummary, { ...paymentInfo })
        ]
      }
    );
  }
);
CoverageSummary.displayName = "CoverageSummary";

// src/components/NextCoverage/NextCoverage.tsx
import { LinkButton, Text } from "@simplybusiness/mobius";
import { useSnowplowContext } from "@simplybusiness/services";
import classNames4 from "classnames/dedupe";
import { forwardRef as forwardRef2 } from "react";
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var NextCoverage = forwardRef2(
  (props, ref) => {
    const { snowplow } = useSnowplowContext();
    const {
      className,
      continuationUrl,
      coverageName,
      componentName,
      ...otherProps
    } = props;
    const classes = classNames4("mobius", "mobius-next-coverage", className);
    const { variant } = otherProps;
    return /* @__PURE__ */ jsxs3(
      "div",
      {
        ref,
        ...otherProps,
        ...componentName ? { "data-component": componentName } : {},
        ...variant ? { "data-variant": variant } : {},
        className: classes,
        "data-testid": "next-coverage",
        children: [
          /* @__PURE__ */ jsxs3(Text, { elementType: "h2", children: [
            "You can still finish your ",
            coverageName,
            " quote online"
          ] }),
          /* @__PURE__ */ jsx4(Text, { variant: "body", className: "mobius-next-coverage__text", children: "You're almost there - just answer a few more questions to receive your quote." }),
          /* @__PURE__ */ jsx4(
            LinkButton,
            {
              href: continuationUrl,
              variant: "secondary",
              size: "sm",
              onClick: () => snowplow?.trigger("nextCoverageClicked", { url: continuationUrl }),
              children: "Finish quote"
            }
          )
        ]
      }
    );
  }
);
NextCoverage.displayName = "NextCoverage";

// src/components/Referral/TrustSection/TrustSection.tsx
import { circleTick } from "@simplybusiness/icons";
import {
  Flex as Flex2,
  Icon,
  List,
  ListItem,
  Segment as Segment2,
  Text as Text2,
  Trust
} from "@simplybusiness/mobius";
import classNames5 from "classnames/dedupe";
import { forwardRef as forwardRef3 } from "react";
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var TrustSection = forwardRef3((props, ref) => {
  const { elementType: Element = "div", ...otherProps } = props;
  const classes = classNames5(
    "mobius",
    "mobius-trust-section",
    otherProps.className
  );
  return /* @__PURE__ */ jsxs4(Element, { ref, ...otherProps, className: classes, children: [
    /* @__PURE__ */ jsx5(Segment2, { className: "mobius-trust-section__header", children: /* @__PURE__ */ jsx5(Text2, { elementType: "h2", children: "How our licensed agents can help" }) }),
    /* @__PURE__ */ jsx5(Segment2, { className: "mobius-trust-section__body", children: /* @__PURE__ */ jsxs4(
      Flex2,
      {
        flexDirection: "column",
        alignItems: "center",
        className: "mobius-trust-section__body-content",
        children: [
          /* @__PURE__ */ jsxs4(
            List,
            {
              icon: /* @__PURE__ */ jsx5(
                Icon,
                {
                  icon: circleTick,
                  color: "var(--color-valid)",
                  title: "Benefits included"
                }
              ),
              className: "mobius-trust-section__list",
              children: [
                /* @__PURE__ */ jsx5(ListItem, { children: /* @__PURE__ */ jsx5(Text2, { children: "Speak to a small business insurance expert" }) }),
                /* @__PURE__ */ jsx5(ListItem, { children: /* @__PURE__ */ jsx5(Text2, { children: "Ask questions and get answers right away" }) }),
                /* @__PURE__ */ jsx5(ListItem, { children: /* @__PURE__ */ jsx5(Text2, { children: "Get coverage for your unique business" }) })
              ]
            }
          ),
          /* @__PURE__ */ jsx5(Trust, { locale: "en-US", theme: "light", variant: "mini" }),
          /* @__PURE__ */ jsx5(Text2, { children: /* @__PURE__ */ jsx5("strong", { children: "150,000 customers served" }) })
        ]
      }
    ) })
  ] });
});
TrustSection.displayName = "TrustSection";

// src/components/Referral/Referral.tsx
import { LinkButton as LinkButton2 } from "@simplybusiness/mobius";
import classNames6 from "classnames/dedupe";
import { forwardRef as forwardRef4 } from "react";

// src/components/Referral/ReferralText.tsx
import { useSnowplowContext as useSnowplowContext2 } from "@simplybusiness/services";
import { Link, Text as Text3 } from "@simplybusiness/mobius";
import { Fragment, jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var ReferralText = (props) => {
  const { firstName, referenceNumber, phoneNumbers, sbDirect, children } = props;
  const { snowplow } = useSnowplowContext2();
  const handleMobileLinkClick = () => snowplow?.trigger("mobileLinkClick");
  return /* @__PURE__ */ jsx6("div", { className: "mobius-referral__text", children: sbDirect ? /* @__PURE__ */ jsxs5(Fragment, { children: [
    /* @__PURE__ */ jsxs5(Text3, { elementType: "h2", children: [
      "Thanks, ",
      firstName
    ] }),
    /* @__PURE__ */ jsx6(Text3, { variant: "body", children: "Based on the information you shared about your business, we are searching for quotes offline." }),
    /* @__PURE__ */ jsx6(Text3, { variant: "body", children: "One of our licensed agents is ready to work with you to help find coverage for your small business." }),
    /* @__PURE__ */ jsxs5(Text3, { variant: "body", children: [
      "You can speak with them at",
      " ",
      /* @__PURE__ */ jsx6(
        Link,
        {
          id: "thank-you-mobile-link-sb",
          href: `tel:${phoneNumbers.contactUs}`,
          onClick: handleMobileLinkClick,
          children: phoneNumbers.contactUs
        }
      )
    ] }),
    children
  ] }) : /* @__PURE__ */ jsxs5(Fragment, { children: [
    /* @__PURE__ */ jsx6(Text3, { elementType: "h2", children: "Thank You!" }),
    /* @__PURE__ */ jsx6(Text3, { variant: "body", children: "We appreciate you taking the time to answer our questions. We're using this info right now to see if we can provide you with a quote." }),
    /* @__PURE__ */ jsxs5(Text3, { variant: "body", children: [
      "If we do find a quote, one of our licensed agents will email you or call you from ",
      phoneNumbers.contactYou,
      ", so be on the lookout!"
    ] }),
    /* @__PURE__ */ jsx6(Text3, { elementType: "h3", children: "Don't want to wait?" }),
    /* @__PURE__ */ jsxs5(Text3, { variant: "body", children: [
      "We get it - you're busy! If you want to reach an agent ASAP about your insurance quote, give us a call at",
      " ",
      /* @__PURE__ */ jsx6(
        Link,
        {
          id: "thank-you-mobile-link-non-sb",
          href: `tel:${phoneNumbers.contactUs}`,
          onClick: handleMobileLinkClick,
          children: phoneNumbers.contactUs
        }
      ),
      " ",
      "at a time that works best for you."
    ] }),
    /* @__PURE__ */ jsxs5(Text3, { variant: "body", children: [
      "Don't forget to have your reference number handy - it's",
      " ",
      referenceNumber,
      "."
    ] }),
    /* @__PURE__ */ jsx6(Text3, { variant: "body", children: "Thanks again for choosing Simply Business!" })
  ] }) });
};

// src/components/Referral/Referral.tsx
import { jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var Referral = forwardRef4((props, ref) => {
  const {
    className,
    firstName,
    showTrustSection,
    referenceNumber,
    phoneNumbers,
    sbDirect,
    checkoutUrl,
    backUrl,
    children,
    componentName,
    ...otherProps
  } = props;
  const classes = classNames6("mobius", "mobius-referral", className);
  const { variant } = otherProps;
  const showCheckoutButtons = variant === "with-coverage-summary" && checkoutUrl;
  const textProps = {
    firstName,
    referenceNumber,
    phoneNumbers,
    sbDirect
  };
  return /* @__PURE__ */ jsxs6(
    "div",
    {
      ref,
      ...otherProps,
      ...componentName ? { "data-component": componentName } : {},
      ...variant ? { "data-variant": variant } : {},
      className: classes,
      "data-testid": "referral",
      children: [
        /* @__PURE__ */ jsx7(ReferralText, { ...textProps, children: showCheckoutButtons && /* @__PURE__ */ jsxs6("div", { className: "mobius-checkout-buttons", children: [
          /* @__PURE__ */ jsx7(
            LinkButton2,
            {
              href: backUrl ?? "#",
              variant: "secondary",
              "data-testid": "back-button",
              children: "Back"
            }
          ),
          /* @__PURE__ */ jsx7(
            LinkButton2,
            {
              href: checkoutUrl,
              variant: "primary",
              "data-testid": "checkout-button",
              children: "Checkout"
            }
          )
        ] }) }),
        showTrustSection && /* @__PURE__ */ jsx7(TrustSection, {}),
        children
      ]
    }
  );
});
Referral.displayName = "Referral";

export {
  CoverageSummary,
  NextCoverage,
  TrustSection,
  Referral
};
